module.exports = __webpack_public_path__ + "static/media/watermark-dark-background.ceb66f8d.svg";